import { useContext } from 'react';
import { ScenariosContext } from '../contexts/ScenariosContextDefinition';
import type { SavedScenario, ReverseCalculationInput, ReverseCalculationResult } from '../types/tax';

export interface ScenariosContextType {
  scenarios: SavedScenario[];
  saveScenario: (name: string, input: ReverseCalculationInput, result: ReverseCalculationResult, inputFrequency: 'monthly' | 'yearly') => SavedScenario;
  updateScenario: (id: string, updates: Partial<Pick<SavedScenario, 'name' | 'input' | 'result' | 'inputFrequency'>>) => void;
  deleteScenario: (id: string) => void;
  clearAllScenarios: () => void;
  getScenario: (id: string) => SavedScenario | null;
  maxScenarios: number;
}

export function useScenarioContext(): ScenariosContextType {
  const context = useContext(ScenariosContext);
  if (context === undefined) {
    throw new Error('useScenarioContext must be used within a ScenariosProvider');
  }
  return context;
}